<template>
	<v-container fluid> Payment </v-container>
</template>

<script>
export default {
	name: 'Payment',
	components: {},
	data: function () {
		return {};
	},
	methods: {},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		this.$myStore.commit('setBreadcrumbs', [
			{ text: this.$t('modules.payments'), href: '/#/payments', disabled: false },
		]);
	},
};
</script>

<style scoped></style>
